<template>
  <teleport to="#modals">
    <div class="acModal" v-if="modelValue">
      <div class="acModal_overlay" @click="onBackdropClose"></div>

      <div :class="['acModal_content', `-${modalType}`, `-mobile-${mobileModalType}`]" @click.self="onBackdropClose">
        <slot />
      </div>
    </div>
  </teleport>
</template>

<script lang="ts">
import { computed, defineComponent, onBeforeUnmount, watch } from 'vue'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    backdropClose: {
      type: Boolean,
      default: true
    },
    modalType: {
      type: String,
      default: 'modal' // modal, bottomSheet
    },
    mobileModalType: {
      type: String,
      default: 'modal' // modal, bottomSheet
    }
  },
  emits: ['update:modelValue'],
  setup (props, ctx) {
    const isBottomSheet = computed(() => props.modalType === 'bottomSheet' || props.mobileModalType === 'bottomSheet')

    onBeforeUnmount(() => {
      document.body.style.overflowY = ''
    })

    function close () {
      ctx.emit('update:modelValue', false)
    }

    function onBackdropClose () {
      if (props.backdropClose) {
        close()
      }
    }

    watch(() => props.modelValue, (val) => {
      if (val) {
        document.body.style.overflowY = 'hidden'
      } else {
        document.body.style.overflowY = ''
      }
    },
    {
      immediate: true
    })

    return {
      close,
      isBottomSheet,
      onBackdropClose
    }
  }
})
</script>

<style lang="scss">
  .acModal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;

    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;

    &_overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      &::after {
        content: '';

        position: absolute;
        top: -2px;
        left: -2px;

        height: calc(100% + 4px);
        width: calc(100% + 4px);

        background-color: rgba(0, 0, 0, .5);
        backdrop-filter: blur(5px);
      }
    }

    &_content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.-bottomSheet {
        position: fixed;
        top: unset;
        bottom: 0;
        left: 0;
        right: 0;
        height: auto;
        max-height: 100%;
        width: 100%;
      }

      @media (max-width: $screen-desktop) {
        &.-mobile-bottomSheet {
          position: fixed;
          top: unset;
          bottom: 0;
          left: 0;
          right: 0;
          height: auto;
          max-height: 100%;
          width: 100%;
        }
      }
    }
  }
</style>
